import { ExtendCurrency, ExtendLocales, SupportedBrands } from 'src/enums'
export interface BrandConfig {
  BRAND_ID: string
  BRAND_NAME: SupportedBrands
  COLOR_CTA: string
  COLOR_CTA_DARK: string
  COLOR_FONT_PRIMARY: string
  COLOR_HIGHLIGHT: string
  COLOR_HIGHLIGHT_DARK: string
  IS_EXTEND_BRAND: string
  APP_NAME: string
  SEGMENT_KEY?: string
  PUSHER_CHANNEL_PREFIX: string
  EXTERNAL_TERMS_URL?: string
  EXTERNAL_FAQ_URL?: string
  EXTERNAL_SUPPORT_URL?: string
  EXTERNAL_SUPPORT_PRETTY_URL?: string
  EXTERNAL_PRIVACY_URL?: string
  PRIMARY_DOMAIN: string
  APP_STORE_LINK?: string
  GOOGLE_PLAY_STORE_LINK?: string
}

export const defaultBrandConfig: BrandConfig = {
  BRAND_ID: '',
  BRAND_NAME: SupportedBrands.Extend,
  COLOR_CTA: '',
  COLOR_CTA_DARK: '',
  COLOR_FONT_PRIMARY: '',
  COLOR_HIGHLIGHT: '',
  COLOR_HIGHLIGHT_DARK: '',
  IS_EXTEND_BRAND: '',
  APP_NAME: '',
  PUSHER_CHANNEL_PREFIX: '',
  PRIMARY_DOMAIN: '',
}

export interface BrandFeaturesConfig {
  integrationsEnabled: boolean
  apiKeysEnabled: boolean
  billPayEnabled: boolean
  recurringVirtualCardsEnabled: boolean
  grayscaleImageEnabled: boolean
}

export const defaultBrandFeaturesConfig: BrandFeaturesConfig = {
  integrationsEnabled: false,
  apiKeysEnabled: false,
  billPayEnabled: false,
  recurringVirtualCardsEnabled: false,
  grayscaleImageEnabled: false,
}

export enum Environments {
  Dev = 'dev',
  Stage = 'stage',
  Prod = 'prod',
  Test = 'test',
}

export interface EnvConfig {
  ENVIRONMENT: Environments
  DATADOG_APP_ID?: string
  DATADOG_CLIENT_TOKEN?: string
  PORT: string
  API_HOST?: string
  AGENT_HOST?: string
  VAULT_HOST?: string
  SENTRY_DSN?: string
  SENTRY_ENV?: string
  ADDRESSULATOR_HOST?: string
  GRAPHQL_HOST?: string
  PUSHER_CLUSTER?: string
  PUSHER_KEY?: string
  PROXULATOR_HOST?: string
  MARKETING_GA_TRACKING_ID?: string
  FEEDBACK_SURVEY_URL?: string
  USERPILOT_APP_TOKEN?: string
  INTERCOM_APP_ID?: string
  VERSION?: string
  MUI_LICENSE_KEY?: string
  MIXPANEL_TOKEN?: string
  APPLE_PAY_URL?: string
  APPLE_PAY_PARTNER_ID?: string
  ASTRADA_3DS_VERIFY_BASE_URL?: string
  TWILIO_FROM_PHONE_NUMBER?: string
}

export const defaultEnvConfig: EnvConfig = {
  ENVIRONMENT: Environments.Dev,
  PORT: '3800',
}

export const defaultWhiteLabelBrand = SupportedBrands.Extend

export const defaultCurrency = ExtendCurrency.Usd

export const defaultLocale = ExtendLocales.enUS
